// Owns UI catalog loading and fallback; domain policy owns supported locale IDs.
import { LOCALES } from '../../packages/domain/src/05-locale.mjs';
export { LOCALES };
let locale = 'en',
  english = {},
  catalog = {};
const cache = new Map();
let generation = 0;
/** Choose a public-screen locale without storing account details or changing account preferences. */
export function publicLocale() {
  let stored;
  try {
    stored = localStorage.getItem('myaudience-ui-locale');
  } catch {
    /* Storage may be disabled. */
  }
  if (Object.hasOwn(LOCALES, stored)) return stored;
  for (const value of navigator.languages ?? [navigator.language]) {
    if (Object.hasOwn(LOCALES, value)) return value;
    const base = value?.split('-')[0];
    if (base === 'pt') return 'pt-BR';
    if (Object.hasOwn(LOCALES, base)) return base;
  }
  return 'en';
}
/** Remember only a supported UI language; private browsing storage failures remain harmless. */
export function rememberPublicLocale(value) {
  if (!Object.hasOwn(LOCALES, value)) return;
  try {
    localStorage.setItem('myaudience-ui-locale', value);
  } catch {
    /* Catalog still works without storage. */
  }
}
/** Missing keys fall back to English; unknown English copy remains readable. Never translate user text. */
export function translate(key, values = {}) {
  return (catalog[key] ?? english[key] ?? key).replace(/\{(\w+)\}/g, (_, name) =>
    String(values[name] ?? `{${name}}`),
  );
}
/** Translate recognized interface copy while preserving unknown text. */
export function uiText(englishText) {
  const key = Object.keys(english).find((key) => english[key] === englishText);
  return key ? translate(key) : englishText;
}
/** Return the locale whose catalog has finished loading. */
export function currentLocale() {
  return locale;
}
/** Load supported catalogs with English fallback; reject failed loads before changing locale. */
export async function setLocale(value) {
  const request = ++generation;
  const selected = Object.hasOwn(LOCALES, value) ? value : 'en';
  const read = async (code) => {
    if (cache.has(code)) return cache.get(code);
    const response = await fetch(`/locales/${code}.json`);
    if (!response.ok) throw new Error('Language pack unavailable.');
    const data = await response.json();
    cache.set(code, data);
    return data;
  };
  const base = await read('en');
  const loaded = selected === 'en' ? base : await read(selected);
  if (request !== generation) return false;
  english = base;
  catalog = loaded;
  locale = selected;
  document.documentElement.lang = selected;
}
